import React, { FC } from 'react';
import { ActionButtonProps } from '../../atoms/ActionButton';
import { HtmlProps } from '../../atoms/Html';
import { VideoProps } from '../../atoms/Video';
import { RecipeIngredientsProps } from '../RecipeIngredients';
import CouponCardsBlock, { CouponCardsBlockProps } from '../CouponCardsBlock';
import { RecipeStepsProps } from '../RecipeSteps';
import ShareButton, { ShareButtonProps } from '../../atoms/ShareButton';
import * as SC from './styled';
export type RecipeMainContentProps = MinimalSeoBlock & {
  className?: string;
  intro?: HtmlProps;
  actions?: (ActionButtonProps | ShareButtonProps)[];
  videoTitle?: string;
  videoProps?: VideoProps;
  ingredientsProps?: RecipeIngredientsProps;
  text?: HtmlProps;
  couponsProps?: CouponCardsBlockProps;
  stepsProps?: RecipeStepsProps;
};
const RecipeMainContent: FC<RecipeMainContentProps> = ({
  className,
  htmlTag,
  intro,
  actions,
  videoTitle,
  htmlTitleTag,
  videoProps,
  ingredientsProps,
  couponsProps,
  stepsProps,
  text
}) => {
  return <SC.Container className={className} as={htmlTag}>
      <SC.Section>
        {intro && <SC.IntroText {...intro} />}
        {actions && <SC.Actions>
            {actions && <SC.Actions>
                {actions.map((action, i) => {
            return 'sharingActions' in action ? <ShareButton {...action} key={i} /> : <SC.Button key={i} {...action} />;
          })}
              </SC.Actions>}
          </SC.Actions>}
      </SC.Section>
      {videoProps && <SC.Section>
          {videoTitle && <SC.VideoTitle as={htmlTitleTag}>{videoTitle}</SC.VideoTitle>}
          {videoProps && <SC.Video {...videoProps} />}
        </SC.Section>}
      {ingredientsProps && <SC.Ingredients {...ingredientsProps} />}
      {couponsProps && <CouponCardsBlock {...couponsProps} />}
      {stepsProps && <SC.Steps {...stepsProps} />}
      {text && <SC.Text {...text} />}
    </SC.Container>;
};
export default RecipeMainContent;